export { MediaFrame, type MediaFrameProps } from './media-frame';
